<template>
    <div>
        <div v-if="!isSubmited" v-loading="isLoading"> 
            <div class="text-center"> 
                <h5><strong>Redeem iRp for Exclusive Top-up Vouchers</strong></h5>
                <p>Use your accumulated iRp (Bonus Points) to get massive bonuses on your next top-up.</p>
            </div>
            <div class="text-center"> 
                <div class="mb-2"><strong>Redemption Options:</strong></div>
                <div>Exchange <strong style="color: #529421;">25 iRp</strong> for a <strong style="color: #529421;">15%</strong> Bonus Voucher</div>
                <div>Exchange <strong style="color: #529421;">50 iRp</strong> for a <strong style="color: #529421;">25%</strong> Bonus Voucher</div>
                <div>Exchange <strong style="color: #529421;">100 iRp</strong> for a <strong style="color: #529421;">50%</strong> Bonus Voucher</div>
            </div>
            <div class="my-4 d-flex justify-content-center"> 
                <div> 
                    <div><strong>Redeem Voucher</strong></div>
                    <div class="mt-2 d-flex align-items-center" style="column-gap: 0.8rem;"> 
                        <div style="width: 250px; border: 1px solid #c5c5c5; border-radius: 8px;"
                            class="px-3 py-2">
                            <strong>{{currentItem.bonusAmount}}{{ currentItem.bonusUnit }} Bonus Voucher</strong>
                        </div>
                        <div style="width: 250px; border: 1px solid #c5c5c5; border-radius: 8px;"
                            class="px-3 py-2 d-flex justify-content-between">
                            <strong>{{currentItem.price}} <ir-point style="margin-bottom: 0.1rem;" color="#606266" size="10px"></ir-point></strong>
                            <span class="text-muted">(extra point)</span>
                        </div>
                        <div> 
                            <button class="green-button-style-2026" @click="redeemBuyVoucher()">Redeem Now</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt-3 text-center" style="font-style: italic;">
                <div>Terms & Conditions:</div>
                <div><i class="ri-arrow-right-double-line"></i> Vouchers are valid for 3 months from the date of redemption.</div>
                <div><i class="ri-arrow-right-double-line"></i> The bonus applies to your next top-up transaction.</div>
            </div>
        </div>
        <div v-if="isSubmited"> 
            <div class="text-center" style="width: 100%; max-width: 800px; margin: 0 auto;">
                <div class="mb-5">
                    <img src="/img/checked.svg" height="50"/>
                </div>
                <h5><strong>Redemption Successful!</strong></h5>
                <div class="mt-7"> 
                    <p style="word-break: break-word;">Congratulations! You have successfully exchanged your iRp for a <strong>{{currentItem.bonusAmount}}</strong>{{ currentItem.bonusUnit }} Bonus Voucher.</p>
                    <p style="word-break: break-word;">Your voucher code is now available in your Voucher Wallet.</p>
                </div>
                <div>
                    <el-button @click="$router.push('/payment-management')">
                        Top-Up Now
                    </el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import promotionApi from '@/api/promotionApi';
import { EXECUTE_RESULT } from "@/constant/baseConstant";
export default {
    props: {
        currentItem: {
            type: Object,
            default: null
        }
    },
    computed: {
        ...mapState({
            user: state => state.auth.user
        }),
    },
    data() {
        return {             
            isSubmited: false,
            isLoading: false,
        }
    },
    mounted() {
        console.log("currentItem in popup: ", this.currentItem);    
    },
    methods: {        
        async redeemBuyVoucher() {
            this.isLoading = true;
            const res = await promotionApi.redeemBuyVoucher(this.currentItem);
            if (res) {
                const data = res.data;
                if (data.result === EXECUTE_RESULT.SUCCESS) {
                    this.$message.success("Submit successfully!");
                    this.isSubmited = true;
                    this.isLoading = false;
                    this.$emit('onRequestReloadList');
                } else {
                    this.isLoading = false;
                    this.$message.error(data.message || "Submit failed!");
                }
            }
            this.isLoading = false;
        },
    }
}
</script>